import comp from "./CustomLoginBoxButton";
export default comp;
